
import { Vue, Component, Watch, Model, Prop } from 'vue-property-decorator';

@Component
export default class ColorField extends Vue {
  colorList: any = [];

  colorObj: any = {};

  val = 'White';

  @Prop()
  readonly!: boolean;

  @Watch('val')
  changeVal() {
    this.$emit('change', this.val);
  }

  @Model('change', {
    type: String,
  })
  value!: string;


  changeColor(val: string) {
    this.val = val;
  }


  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = this.value;
    } else {
      this.val = '';
    }
  }
  breakDown(val: any) {
    const _a: any = [];
    Object.keys(val).forEach((key) => {
      if (key) {
        const item = {
          cn: val[key]?.desc,
          en: key,
          value: val[key]?.code,
          color: val[key]?.code,
        };
        _a.push(item);
      }
    });
    return _a;
  }
  mounted() {
    this.watchValue();
    const carFields = JSON.parse(localStorage.getItem('carFields') || '{}');
    const { color } = carFields;
    this.colorObj = color;
    this.colorList = this.breakDown(color);
  }
}

